import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-arrow-lg-down",
  "use": "app-icon-arrow-lg-down-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-arrow-lg-down\"><path fill=\"#4D84FF\" d=\"M8 12.33l7.24-7.25-1.41-1.41L8 9.5 2.17 3.67.76 5.08 8 12.33z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol